import { useEffect } from 'react'
import { StringParam, useQueryParam } from 'use-query-params'

import { Toasts } from '@fourthwall/components'

export const useErrorQueryParam = () => {
  const [errorQueryParam, setErrorQueryParam] = useQueryParam('error', StringParam)

  const MESSAGES = {
    USER_ALREADY_CONNECTED:
      'This StreamElements account is already connected to another Fourthwall site.',
  }

  const isValidError = (error: string): error is keyof typeof MESSAGES => {
    return Object.keys(MESSAGES).includes(error)
  }

  useEffect(() => {
    if (errorQueryParam) {
      if (!isValidError(errorQueryParam)) {
        throw new Error(`Unknown error query param: ${errorQueryParam}.`)
      }

      Toasts.notify(MESSAGES[errorQueryParam], { type: 'error' })
      setErrorQueryParam(undefined, 'replaceIn')
    }
  }, [errorQueryParam, setErrorQueryParam])
}
